module.exports = __webpack_public_path__ + "img/cases-brand-13.d1ff3019.png";